import { render, staticRenderFns } from "./CeurLanding.vue?vue&type=template&id=5415e7a9"
import script from "./CeurLanding.vue?vue&type=script&lang=js"
export * from "./CeurLanding.vue?vue&type=script&lang=js"
import style0 from "./CeurLanding.vue?vue&type=style&index=0&id=5415e7a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports